import Http from '../Http';

const baseUrl = `${process.env.VAPI_BASE_URL}/screenresolutions`;

export default {
  list: (data, options) => Http.post(`${baseUrl}/search`, data, options),
  getById: (id, options) => Http.get(`${baseUrl}/${id}`, options),
  create: (data, options) => Http.post(baseUrl, data, options),
  update: (data, options) => Http.put(`${baseUrl}/${data._id}`, data, options),
  reactivate: (data, options) => Http.post(`${baseUrl}/${data._id}`, data, options),
  deactivate: (id) => Http.delete(`${baseUrl}/${id}`),
};
